<template>
  <v-container>
    <v-expansion-panels class="mb-5" :mandatory="true">
      <v-expansion-panel>
        <v-expansion-panel-header> Цены на услуги </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-expansion-panels class="informations_services" focusable>
            <v-expansion-panel v-for="(item, index) in services" :key="index">
              <v-expansion-panel-header>{{
                item.name
              }}</v-expansion-panel-header>
              <v-expansion-panel-content>
                <div
                  v-for="(sub, i) in item.sub"
                  :key="i"
                  class="mb-5 pl-3 pr-3 pt-1 pb-1 subprogram"
                >
                  <div class="subprogram_name">{{ sub.name }}</div>
                  <div>
                    <v-chip
                      v-for="(val, key) in sub.value.time"
                      :key="key"
                      class="ml-1"
                    >
                      {{ typeof val == "number" ? val + "мин." : val }} -
                      {{ sub.value.price[key] + "руб." }}
                    </v-chip>
                  </div>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <h2 class="heading_label">Онлайн-запись</h2>

    <!-- <div class="wrap" id="receipt_before" v-if="success && !receiptStatus">
      <div class="head">
        <div>
          <h3>Подтверждение заказа</h3>
          <p>Проверьте достоверность услуги и подтвердите</p>
        </div>
      </div>
      <div class="body">
        <ul>
          <li>
            <span>Услуга</span><span>{{ programName }}</span>
          </li>
          <li>
            <span>Подуслуга</span><span>{{ subProgramName }}</span>
          </li>
          <li>
            <span>Опция</span><span>{{ lengthService }}</span>
          </li>
          <li>
            <span>Дата бронирования</span><span>{{ date }}</span>
          </li>
          <li>
            <span>Время бронирования</span><span>{{ time }}</span>
          </li>
          <li><span>Метод оплаты</span><span>Банковская карта</span></li>
        </ul>
      </div>
      <div class="footer">
        <div class="total">
          Итого: <span>{{ priceService + "руб." }}</span>
        </div>
        <v-btn depressed color="success" @click="payOrder"
          >Перейти к оплате</v-btn
        >
      </div>
    </div> -->

    <!-- <div id="payment_status" v-if="receiptStatus">
      <div class="success_payment" v-if="receiptData.paid">
        <div class="animation-ctn">
          <div class="icon icon--order-success svg">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="154px"
              height="154px"
            >
              <g fill="none" stroke="#22AE73" stroke-width="2">
                <circle
                  cx="77"
                  cy="77"
                  r="72"
                  style="
                    stroke-dasharray: 480px, 480px;
                    stroke-dashoffset: 960px;
                  "
                ></circle>
                <circle
                  id="colored"
                  fill="#22AE73"
                  cx="77"
                  cy="77"
                  r="72"
                  style="
                    stroke-dasharray: 480px, 480px;
                    stroke-dashoffset: 960px;
                  "
                ></circle>
                <polyline
                  class="st0"
                  stroke="#fff"
                  stroke-width="10"
                  points="43.5,77.8 63.7,97.9 112.2,49.4 "
                  style="
                    stroke-dasharray: 100px, 100px;
                    stroke-dashoffset: 200px;
                  "
                />
              </g>
            </svg>
          </div>
        </div>
        <p>Вы успешно записались на прием</p>
      </div>
      <div class="failed_payment" v-if="!receiptData.paid">
        <div class="animation-ctn">
          <div class="icon icon--order-success svg">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="154px"
              height="154px"
            >
              <g fill="none" stroke="#F44812" stroke-width="2">
                <circle
                  cx="77"
                  cy="77"
                  r="72"
                  style="
                    stroke-dasharray: 480px, 480px;
                    stroke-dashoffset: 960px;
                  "
                ></circle>
                <circle
                  id="colored"
                  fill="#F44812"
                  cx="77"
                  cy="77"
                  r="72"
                  style="
                    stroke-dasharray: 480px, 480px;
                    stroke-dashoffset: 960px;
                  "
                ></circle>
                <polyline
                  class="st0"
                  stroke="#fff"
                  stroke-width="10"
                  points="43.5,77.8  112.2,77.8 "
                  style="
                    stroke-dasharray: 100px, 100px;
                    stroke-dashoffset: 200px;
                  "
                />
              </g>
            </svg>
          </div>
        </div>
        <p>Платеж не прошел</p>
      </div>

      <v-btn color="primary" depressed href="/book-an-appointment/"
        >Назад</v-btn
      >
    </div> -->

    <!-- <form v-if="!success && !receiptStatus">
      <v-text-field label="Имя" filled v-model="name"></v-text-field>
      <v-text-field
        label="Телефон"
        filled
        v-mask="'+7 (###) ### ##-##'"
        v-model="phone"
      ></v-text-field>
      <v-menu
        v-model="datePicker"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="date"
            filled
            label="Дата"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="date"
          :min="new Date().toISOString().slice(0, 10)"
          @input="datePicker = false"
        ></v-date-picker>
      </v-menu>

      <v-menu
        ref="menu"
        v-model="timePicker"
        :close-on-content-click="false"
        :nudge-right="40"
        :return-value.sync="time"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="time"
            label="Время"
            filled
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-time-picker
          v-if="timePicker"
          v-model="time"
          format="24hr"
          full-width
          @click:minute="$refs.menu.save(time)"
          min="10:00"
          max="22:00"
          :allowed-minutes="allowedStep"
        ></v-time-picker>
      </v-menu>

      <v-select
        :items="services"
        item-text="name"
        item-value="sub"
        filled
        label="Тип услуги"
        v-model="checkedParent"
        return-object
        @change="changeProgramName"
      ></v-select>

      <v-select
        :items="checkedParent ? checkedParent.sub : []"
        item-text="name"
        item-value="value"
        filled
        label="Тип массажа"
        v-model="checkedSub"
        return-object
        @change="changeSubProgramName"
      ></v-select>

      <div class="length" v-if="checkedSub">
        <label>Опция</label>
        <v-chip
          v-for="(length, index) in checkedSub.value.time"
          :key="index"
          :class="lengthService == length ? 'active mr-5' : 'mr-5'"
          :color="lengthService == length ? 'green' : 'primary'"
          text-color="white"
          @click="changeLength(index)"
        >
          {{ length }} {{ typeof length == "number" ? "минут" : "" }}
          <v-icon
            v-if="lengthService == length ? true : false"
            small
            class="ml-1"
            >mdi-check</v-icon
          >
        </v-chip>
      </div>

      <v-divider v-if="priceService" class="mt-5 mb-5"></v-divider>

      <div class="price d-flex align-center" v-if="priceService">
        <v-chip large class="mr-5">
          Цена услуги:&nbsp;<strong>{{ priceService }}руб.</strong>
        </v-chip>
        <v-btn depressed color="primary" large @click="bookService">
          Записаться
        </v-btn>
      </div>
    </form> -->

    <!-- <v-snackbar v-model="snackbar">
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Закрыть
        </v-btn>
      </template>
    </v-snackbar> -->
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  name: "Booking",
  data: () => ({
    name: "",
    phone: "",
    date: "",
    time: "",
    programName: "",
    subProgramName: "",
    lengthService: "",
    priceService: "",

    allowedStep: (m) => m % 30 === 0,
    datePicker: false,
    timePicker: false,

    services: [
      {
        name: "Тайские традиционные техники массажа",
        sub: [
          {
            name: "Тайский традиционный массаж",
            value: {
              time: [60, 90, 120],
              price: [3200, 4500, 5700],
            },
          },
          {
            name: "Спортивный массаж с применением бальзама на выбор",
            value: {
              time: [60, 90, 120],
              price: [3700, 5000, 6400],
            },
          },
          {
            name: "Тайский традиционный массаж в 4 руки",
            value: {
              time: [60, 90, 120],
              price: [5100, 7200, 9100],
            },
          },
          {
            name: "Сегментарный массаж (голова, плечевой пояс, спина, ноги, стопы)",
            value: {
              time: [30, 60],
              price: [2400, 3200],
            },
          },
        ],
      },

      {
        name: "Масляные техники массажа",
        sub: [
          {
            name: "Тайский ойл массаж",
            value: {
              time: [60, 90, 120],
              price: [3700, 5000, 6400],
            },
          },
          {
            name: "Тайский ойл массаж в 4 руки",
            value: {
              time: [60, 90, 120],
              price: [5900, 8000, 10200],
            },
          },
          {
            name: "Тайский ойл массаж с тёплым маслом",
            value: {
              time: [60, 90, 120],
              price: [3700, 5000, 6400],
            },
          },
          {
            name: "Балийский ойл массаж",
            value: {
              time: [60, 90, 120],
              price: [3700, 5000, 6400],
            },
          },
          {
            name: "Арома-массаж с кремом",
            value: {
              time: [60, 90, 120],
              price: [3700, 5000, 6400],
            },
          },
        ],
      },
      {
        name: "Согревающие процедуры",
        sub: [
          {
            name: "Массаж теплыми травяными мешочками",
            value: {
              time: [60, 90, 120],
              price: [4200, 5600, 7050],
            },
          },
          {
            name: "Массаж теплыми травяными мешочками и тайский традиционный массаж",
            value: {
              time: [120],
              price: [6800],
            },
          },
          {
            name: "Массаж теплыми травяными мешочками и ойл массаж",
            value: {
              time: [120],
              price: [7100],
            },
          },
          {
            name: "Стоун-терапия",
            value: {
              time: [60, 90, 120],
              price: [3800, 5200, 6650],
            },
          },
          {
            name: "Стоун-терапия и тайский традиционный массаж",
            value: {
              time: [120],
              price: [6400],
            },
          },
          {
            name: "Стоун-терапия и ойл массаж",
            value: {
              time: [120],
              price: [6700],
            },
          },
        ],
      },
      {
        name: "Процедуры для коррекции фигуры",
        sub: [
          {
            name: "Слим-микс массаж проблемных зон",
            value: {
              time: [60, 90],
              price: [4000, 5500],
            },
          },
          {
            name: "Антицеллюлитный массаж проблемных зон",
            value: {
              time: [60, 90],
              price: [4000, 5500],
            },
          },
          {
            name: "Спа-программа Идеальный силуэт",
            value: {
              time: [120],
              price: [7000],
            },
          },
          {
            name: "Спа-программа Само Совершенство (с глиной)",
            value: {
              time: [120],
              price: [7100],
            },
          },
          {
            name: "Стоун-терапия",
            value: {
              time: [150],
              price: [8200],
            },
          },
          {
            name: "Спа-программа Детокс (с водорослями)",
            value: {
              time: [150],
              price: [8200],
            },
          },
        ],
      },

      {
        name: "Уходовые процедуры для лица",
        sub: [
          {
            name: "Точечный тайский массаж лица",
            value: {
              time: [60],
              price: [4000],
            },
          },
          {
            name: "Традиционный балийский массаж лица",
            value: {
              time: [60],
              price: [4000],
            },
          },
          {
            name: "Спа-программа для лица плюс массаж ног в подарок",
            value: {
              time: [90],
              price: [5500],
            },
          },
        ],
      },

      {
        name: "СПА-программы",
        sub: [
          {
            name: "Обертывание на выбор плюс массаж головы в подарок",
            value: {
              time: [30],
              price: [3000],
            },
          },
          {
            name: "Скрабирование на выбор (перед процедурой рекомендовано парение)",
            value: {
              time: [30],
              price: [3000],
            },
          },
          {
            name: "Спа-программа Шоколадное облако плюс массаж головы в подарок",
            value: {
              time: [150, "На 2 персоны", "На 3 персоны"],
              price: [8200, 11500, 16000],
            },
          },
          {
            name: "Спа-программа Сила природы (виноград) плюс массаж головы в подарок",
            value: {
              time: [150, "На 2 персоны", "На 3 персоны"],
              price: [8200, 11500, 16000],
            },
          },
          {
            name: "Спа-программа Фруктовое удовольствие (манго) плюс массаж головы в подарок",
            value: {
              time: [150, "На 2 персоны", "На 3 персоны"],
              price: [8200, 11500, 16000],
            },
          },
          {
            name: "Спа-программа питание и восстановление (Мед) плюс массаж головы в подарок",
            value: {
              time: [180, "На 2 персоны", "На 3 персоны"],
              price: [9500, 13000, 17200],
            },
          },
          {
            name: "Спа-программа для мужчин",
            value: {
              time: [120],
              price: [7000],
            },
          },
        ],
      },

      {
        name: "СПА-программы для пар",
        sub: [
          {
            name: "Спа-программа Для влюбленных ",
            value: {
              time: [150],
              price: [11500],
            },
          },
          {
            name: "Спа-программа Рандеву (стоун-терапия)",
            value: {
              time: [150],
              price: [11500],
            },
          },
          {
            name: "Спа-программа Релакс для пары",
            value: {
              time: [150],
              price: [11500],
            },
          },
        ],
      },

      {
        name: "Хаммам",
        sub: [
          {
            name: "Парение",
            value: {
              time: [30],
              price: [2000],
            },
          },
          {
            name: "Скраб соль",
            value: {
              time: [30],
              price: [3500],
            },
          },
          {
            name: 'Пилинг рукавичкой "Кесса"',
            value: {
              time: [30],
              price: [3500],
            },
          },
        ],
      },
    ],
    checkedParent: "",
    checkedSub: "",

    success: false,

    snackbar: false,
    snakbarText: "",
    returnID: "",
    payment: {},
    receiptStatus: false,
    receiptData: {},
  }),
  created() {
    const queryString = window.location.search;
    if (queryString.includes("?receipt=true")) {
      this.receiptStatus = true;

      axios
        .get(
          `${process.env.VUE_APP_MAINURL}/booking/pay/${localStorage.getItem(
            "pid"
          )}`
        )
        .then(
          (res) => {
            this.receiptData = res.data;
          },
          (err) => {
            console.log(err);
          }
        );
    }
  },
  methods: {
    changeProgramName(object) {
      this.checkedSub = "";
      this.programName = object.name;
    },
    changeSubProgramName(object) {
      this.subProgramName = object.name;
    },
    changeLength(time) {
      this.lengthService = this.checkedSub.value.time[time];
      this.priceService = this.checkedSub.value.price[time];
    },
    bookService() {
      let data = {
        date: new Date(Date.now()).getTime(),
        name: this.name,
        phone: this.phone,
        date_booking: this.date,
        time_booking: this.time,
        program: this.programName,
        subprogram: this.subProgramName,
        option: this.lengthService,
        price: this.priceService,
      };

      if (data.name.length == 0) {
        this.snackbar = true;
        this.snakbarText = "Введите свое имя";
      }
      if (data.phone.length == 0) {
        this.snackbar = true;
        this.snakbarText = "Введите свой телефон";
      }
      if (data.date_booking.length == 0) {
        this.snackbar = true;
        this.snakbarText = "Выберите дату";
      }
      if (data.time_booking.length == 0) {
        this.snackbar = true;
        this.snakbarText = "Выберите время";
      }
      if (data.program.length == 0) {
        this.snackbar = true;
        this.snakbarText = "Выберите программу";
      }
      if (data.subprogram.length == 0) {
        this.snackbar = true;
        this.snakbarText = "Выберите тип массажа";
      }
      if (data.option.length == 0) {
        this.snackbar = true;
        this.snakbarText = "Выберите опцию";
      }

      if (
        data.name &&
        data.phone &&
        data.date_booking &&
        data.time_booking &&
        data.program &&
        data.subprogram &&
        data.option
      ) {
        axios.post(`${process.env.VUE_APP_MAINURL}/booking/new`, data).then(
          (res) => {
            if (res.status == 200) {
              this.returnID = res.data.id;
              this.success = true;

              this.pay();
              // console.log(res.data);
            }
          },
          (err) => {
            console.log(err);
          }
        );
      }
    },
    pay() {
      let data = {
        id: this.returnID,
        amount: 1,
        description:
          "Оплата услуги " + this.programName + ",  " + this.subProgramName,
        phone: this.phone,
        name: this.name,
      };
      axios.post(`${process.env.VUE_APP_MAINURL}/booking/pay`, data).then(
        (res) => {
          this.payment = res.data;
          console.log(res);
        },
        (err) => {
          console.log(err);
        }
      );
    },
    payOrder() {
      localStorage.setItem("pid", this.payment.id);

      window.open(this.payment.confirmation.confirmation_url, "_blank").focus();
    },
  },
};
</script>

<style lang="scss" scoped>
.heading_label {
  font-family: "Playfair Display", serif !important;
  font-size: 40px;
  font-weight: 400;
  text-align: center;
  margin: 40px 0 20px 0;
}

.length label {
  display: block;
  width: 100%;
  margin-bottom: 10px;
}

.v-alert__icon {
  align-self: center !important;
}

.subprogram {
  border: 1px solid #f3f3f3;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.informations_services > div::before {
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.1) !important;
}

.subprogram .subprogram_name {
  font-size: 0.9375rem;
}

.v-expansion-panel-content__wrap > .subprogram:first-child {
  margin-top: 16px;
}

#payment_status {
  max-width: 400px;
  margin: 0 auto;
  background-color: #f1f1f1;
  padding: 20px;
  border-radius: 3px;
  text-align: center;
  p {
    text-align: center;
  }
}

#receipt_before {
  max-width: 400px;
  margin: 0 auto;
  background-color: #f1f1f1;
  position: relative;
  &::after {
    background: linear-gradient(-45deg, #fff 16px, transparent 0),
      linear-gradient(45deg, #fff 16px, transparent 0);
    background-position: left-bottom;
    background-repeat: repeat-x;
    background-size: 32px 32px;
    content: " ";
    display: block;
    position: absolute;
    bottom: 0px;
    left: 0px;
    width: 100%;
    height: 32px;
  }

  .head {
    padding: 20px;
    background-color: #5b3a2b;
    display: flex;
    justify-content: space-between;
    align-items: center;

    h3 {
      font-size: 18px;
      font-weight: 500;
      color: #fff;
    }

    p {
      font-size: 14px;
      font-weight: 300;
      color: #fff;
      margin: 0;
    }
  }

  .body {
    margin-top: 15px;
    padding: 20px;

    ul {
      list-style: none;
      margin: 0;
      padding: 0;

      li {
        display: flex;
        justify-content: space-between;
        margin-bottom: 5px;
        padding-bottom: 5px;
        border-bottom: 1px dashed #2a2a2a;
        span {
          font-size: 14px;
        }
      }
    }
  }

  .footer {
    margin-top: 10px;
    padding: 20px 20px 45px 20px;
    border-top: 1px solid #ccc;
    text-align: center;

    .total {
      display: flex;
      justify-content: space-between;
      font-weight: 18px;

      span {
        font-weight: 500;
      }
    }

    button {
      margin: 10px auto 0 auto;
    }
  }
}

.animation-ctn {
  text-align: center;
}

@-webkit-keyframes checkmark {
  0% {
    stroke-dashoffset: 100px;
  }

  100% {
    stroke-dashoffset: 200px;
  }
}

@-ms-keyframes checkmark {
  0% {
    stroke-dashoffset: 100px;
  }

  100% {
    stroke-dashoffset: 200px;
  }
}

@keyframes checkmark {
  0% {
    stroke-dashoffset: 100px;
  }

  100% {
    stroke-dashoffset: 0px;
  }
}

@-webkit-keyframes checkmark-circle {
  0% {
    stroke-dashoffset: 480px;
  }

  100% {
    stroke-dashoffset: 960px;
  }
}

@-ms-keyframes checkmark-circle {
  0% {
    stroke-dashoffset: 240px;
  }

  100% {
    stroke-dashoffset: 480px;
  }
}

@keyframes checkmark-circle {
  0% {
    stroke-dashoffset: 480px;
  }

  100% {
    stroke-dashoffset: 960px;
  }
}

@keyframes colored-circle {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 100;
  }
}

/* other styles */
/* .svg svg {
    display: none
}
 */
.inlinesvg .svg svg {
  display: inline;
}

/* .svg img {
    display: none
} */

.icon--order-success svg polyline {
  -webkit-animation: checkmark 0.25s ease-in-out 0.7s backwards;
  animation: checkmark 0.25s ease-in-out 0.7s backwards;
}

.icon--order-success svg circle {
  -webkit-animation: checkmark-circle 0.6s ease-in-out backwards;
  animation: checkmark-circle 0.6s ease-in-out backwards;
}
.icon--order-success svg circle#colored {
  -webkit-animation: colored-circle 0.6s ease-in-out 0.7s backwards;
  animation: colored-circle 0.6s ease-in-out 0.7s backwards;
}

@media screen and (max-width: 600px) {
  .subprogram {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .subprogram > div {
    margin-bottom: 10px;
  }

  .subprogram > div:last-child span {
    margin-bottom: 10px;
  }
}
</style>